import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Theme } from '@definitions/theme';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ThemesService } from '../services/themes.service';

export const themeResolverFn = (
	route: ActivatedRouteSnapshot
): Observable<Partial<Theme>> => {
	const themeSvc = inject(ThemesService);
	const themeId = route.paramMap.get('themeId');

	return themeId && themeId !== 'new'
		? themeSvc.find(themeId).pipe(catchError(() => of(null)))
		: of(null);
};
